<template>

    <el-select :size="size"
               :value="value"
               :multiple="multiple"
               :collapse-tags="collapse"
               :filterable="filterable"
               :disabled="disabled"
               :clearable="clearable"
               @change="change($event)" style="width: 100%;">
        <el-option v-for="item in sysroomList" :label="item.name" :value="item.id"
                   :key="item.id"></el-option>
    </el-select>

</template>


<script>

    import {createNamespacedHelpers} from 'vuex';

    const sysroomNSHelper = createNamespacedHelpers("sysroom");

    export default {

        name: 'deptSelect',

        props: {
            value: {
                type: Number
            },
            multiple: {
                type: Boolean
            },
            filterable: {
                type: Boolean
            },
            clearable: {
                type: Boolean
            },
            disabled: {
                type: Boolean
            },
            size: {
                type: String
            },
            collapse: {
                type: Boolean
            },
            byAuth: {
                type: Boolean,
                default: true,
            }
        },

        data() {
            return {
                sysroomList: [],
            }
        },

        mounted() {

            if (this.byAuth == false) {
                this.getAllSysroomSource();
            } else {
                this.getSysroomSource();
            }

            let that = this;

            this.sysroomSource$.subscribe(v => {

                that.sysroomList = v;
                this.$emit('fetchAllSysrooms', that.sysroomList);
            });

        },

        methods: {

            ...sysroomNSHelper.mapActions(['getSysroomSource']),    //根据登录人员权限返回数据中心
            ...sysroomNSHelper.mapActions(['getAllSysroomSource']), //返回所有数据中心

            change: function (keys) {
                this.$emit('input', keys);

                this.$emit('change',keys);
            },

        },

        computed: {
            ...sysroomNSHelper.mapGetters(['sysroomSource$']),
        },


    }

</script>

